/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Multica_Th2Inputs */

const en_mk_cmp_multica_th2 = /** @type {(inputs: Mk_Cmp_Multica_Th2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Engineering teams already fluent with coding agents.`)
};

const id_mk_cmp_multica_th2 = /** @type {(inputs: Mk_Cmp_Multica_Th2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tim engineering yang sudah terbiasa dengan coding agent.`)
};

/**
* | output |
* | --- |
* | "Engineering teams already fluent with coding agents." |
*
* @param {Mk_Cmp_Multica_Th2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_multica_th2 = /** @type {((inputs?: Mk_Cmp_Multica_Th2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Multica_Th2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_multica_th2(inputs)
	return en_mk_cmp_multica_th2(inputs)
});